<template>
  <div id="app">
    <div class="top-banner page-width-warpper">
      <el-carousel
          height="auto"
          :interval="3000"
          arrow="never"
          indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in bannerImages" :key="index">
          <img :src="item || defaultImg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <Header
      :isHyaline="false"
      :hyalineHeight="!isHome ? 60 : 100"
      :scrollHeight="!isHome ? 80 : 140"
    />
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { pageByCode } from "@/api/index";
import defaultImg from "@/assets/images/top_Back.jpg";
export default {
  components: {
    Header,
    Footer,
  },
  data: () => ({
    include: [],
    isHome: false,
    image: "",
    bannerImages: [], // 存储多张banner图片
    defaultImg,
  }),
  watch: {
    $route(to, from) {
      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      // if (to.meta.keepAlive) {
      //   !this.include.includes(to.name) && this.include.push(to.name);
      // }
      this.isHome = to.fullPath === "/";
      console.log(this.isHome);
    },
  },
  created() {
    this.isHome = this.$route.fullPath === "/";
    pageByCode({ pageNum: 1, pageSize: 10, code: "year_banner" }).then((res) => {
      const resList = res.data?.records || [];
      if (!resList.length) {
        // 如果没有获取到banner数据，使用默认图片
        this.bannerImages = [defaultImg];
        return;
      }
      // 将所有图片地址存入数组
      this.bannerImages = resList.map(item => item.icon);
      // 如果只有一张图片，也添加默认图片确保至少有两张用于轮播
      if (this.bannerImages.length === 1) {
        this.bannerImages.push(defaultImg);
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.top-banner {
  // 确保容器有高度
  min-height: 200px;

  ::v-deep .el-carousel {
    // 设置轮播图容器高度
    .el-carousel__container {
      height: 200px !important;
    }

    .el-carousel__item {
      // 确保每个轮播项占满容器
      height: 100%;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover; // 保持图片比例并填充容器
      }
    }
  }
}
</style>
